import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import {
  type IBundleInfo,
  type IDocumentInfo,
  type IUserDetails,
  type IUserOnboarding,
  type MarketingTracking,
} from "@types";

export interface ITrackingInfo extends MarketingTracking {
  id: string;
  applicationUserId: IUserDetails["id"];
  documentInfoId: IDocumentInfo["id"] | null;
  bundleInfoId: IBundleInfo["id"] | null;
  userOnboardingId: IUserOnboarding["id"] | null;
}

export type PostTrackingInfoBody = MarketingTracking &
  (
    | { documentInfoId: IDocumentInfo["id"]; bundleInfoId?: never; userOnboardingId?: never }
    | { bundleInfoId: IBundleInfo["id"]; documentInfoId?: never; userOnboardingId?: never }
    | { userOnboardingId: IUserOnboarding["id"]; documentInfoId?: never; bundleInfoId?: never }
  );

export const TRACKING_INFO_API_REDUCER_KEY = "trackingInfoApi";
export const trackingInfoApi = createApi({
  reducerPath: TRACKING_INFO_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      ...extraOptions,
      isExternalService: true,
    }),
  endpoints: (builder) => ({
    postTrackingInfo: builder.mutation<ITrackingInfo, PostTrackingInfoBody>({
      query: (body) => ({
        url: "/tracking-info",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { usePostTrackingInfoMutation } = trackingInfoApi;
